export default "__VITE_ASSET__bSdS2m9G__"